// extracted by mini-css-extract-plugin
export default {"appBar":"AppBar_appBar__OsgIs","userAvatar":"AppBar_userAvatar__XgC4q"};